import { AxiosPromise } from "axios";
import Authentication from "../../../domain/authentication/Authentication";
import { AuthenticationRepository } from "../../../domain/authentication/AuthenticationRepository";
import { ApiClient } from "../../configure/ApiClientConfig";

export default class AuthenticationDataSource implements AuthenticationRepository {
  public login(authentication: Authentication): AxiosPromise {
    return ApiClient.post("/login", JSON.stringify({
      loginId: authentication.loginId.value,
      loginPassword: authentication.loginPassword.value,
    }));
  }

  public logout(): AxiosPromise {
    return ApiClient.post("/logout");
  }

  getAccount(): AxiosPromise<any> {
    return ApiClient.get("/account");
  }
}